import { Controller } from '@hotwired/stimulus'
import GLightbox from 'glightbox';

export default class extends Controller {
  close(e) {
    e.preventDefault()
    const popupVisible = document.querySelector('.popup_visible')
    const popupProductForm = document.querySelector('.popup_product-form')
    const popupProductSuccess = document.querySelector('.popup_product-success')
    const orderForm = document.querySelector('.order-form')
    const delivery = document.querySelector('.order-form__delivery')
    
    if (popupVisible) {
      popupVisible.classList.remove('popup_visible')
    }
    if (popupProductForm) {
      popupVisible.classList.remove('popup_product-form')
    }
    if (popupProductSuccess) {
      popupVisible.classList.remove('popup_product-success')
    }

    orderForm.reset()
    delivery.classList.add('order-form__delivery_hidden')
    history.pushState('', document.title, '/');
  }

  stop(e) {
    e.stopPropagation()
  }

  gallery(e) {
    const images = document.querySelectorAll('.product-images img')
    const urls = Array.from(images).map(image => image.getAttribute('src'))
    const viewGallery = GLightbox({
      elements: [...urls.map(url => ({ 'href': `${location.origin}${url}`, 'type': 'image' }))],
      startAt: e.currentTarget.getAttribute('data-index')
    })

    viewGallery.open()
  }
}
